@if (show) {
<div class="fixed inset-0 flex items-center justify-center bg-black/70 bg-opacity-50 z-50">
  <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
    <h2 class="text-lg font-semibold mb-4 text-gray-800">{{ message }}</h2>
    <div class="flex justify-end space-x-2">
      <button
        class="px-4 py-2 text-sm text-gray-600 bg-gray-200 rounded hover:bg-gray-300"
        (click)="onCancel()"
      >
        Cancelar
      </button>
      <button
        class="px-4 py-2 text-sm text-white bg-red-600 rounded hover:bg-red-700"
        (click)="onConfirm()"
      >
        Confirmar
      </button>
    </div>
  </div>
</div>
}
